import React, { useState } from 'react';

// Styles
import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Grid, Typography } from '@mui/material';

// Components
import { DraggableAccordionDraw } from './DraggableAccordionDraw';
import { ModalRemoveItemDraw } from './ModalRemoveItemDraw';

export const DrawItems = ({ drawData, setDrawData, drawSettings, isNotRaffle }) => {
  const [expandedAccordion, setExpandedAccordion] = useState(0);
  const [confirmDelete, setConfirmDelete] = useState({
    open: false,
    index: null,
  });

  const onAddDraw = () => {
    setDrawData((prevDrawData) => {
      const newRaffleVouchers = [
        ...prevDrawData.raffleVouchers,
        {
          description: '',
          store: '',
        },
      ];

      // Atualiza também o accordion com o novo índice
      setExpandedAccordion(newRaffleVouchers.length - 1);

      return {
        ...prevDrawData,
        raffleVouchers: newRaffleVouchers,
      };
    });
  };

  const handleDeleteDraw = (raffleIndexToRemove) => {
    setDrawData((prevDrawData) => {
      const updatedRaffleVouchers = [...prevDrawData.raffleVouchers];

      // Impede remoção se só houver um sorteio
      if (updatedRaffleVouchers.length <= 1) {
        return prevDrawData;
      }

      updatedRaffleVouchers.splice(raffleIndexToRemove, 1);

      return {
        ...prevDrawData,
        raffleVouchers: updatedRaffleVouchers,
      };
    });

    setConfirmDelete({ open: false, index: null });
    setExpandedAccordion(null);
  };

  const handleChangeDraw = (raffleIndex, field, value) => {
    setDrawData((prevDrawData) => {
      const updatedRaffleVouchers = [...prevDrawData.raffleVouchers];

      updatedRaffleVouchers[raffleIndex] = {
        ...updatedRaffleVouchers[raffleIndex],
        [field]: value,
      };

      return {
        ...prevDrawData,
        raffleVouchers: updatedRaffleVouchers,
      };
    });
  };

  const openDeleteDialog = (indexToRemove) => {
    setConfirmDelete({ open: true, index: indexToRemove });
  };

  return (
    <Grid container spacing={1}>
      <Grid item md={12} xs={12} sx={{ width: '100%' }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ width: '95%', m: '0 auto', mt: '1.2rem', mb: '1rem' }}
        >
          <Typography variant="body" sx={{ fontWeight: 700, fontSize: '1.2rem' }}>
            Lista de sorteios:
          </Typography>
          {isNotRaffle && (
            <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={onAddDraw}>
              Adicionar Sorteio
            </Button>
          )}
        </Box>
        {drawSettings?.hasUsersList && isNotRaffle && (
          <Typography variant="caption" sx={{ color: 'red', fontSize: '0.8rem' }}>
            * A lista de participantes já foi gerada. A partir deste momento, alterações não são
            mais permitidas — apenas a adição de novos sorteios está disponível.
          </Typography>
        )}
        <DraggableAccordionDraw
          drawSettings={drawSettings}
          form={drawData}
          setForm={setDrawData}
          setExpandedAccordion={setExpandedAccordion}
          expandedAccordion={expandedAccordion}
          handleDeleteDraw={openDeleteDialog}
          handleChangeDraw={handleChangeDraw}
          isNotRaffle={isNotRaffle}
        />
      </Grid>
      <ModalRemoveItemDraw
        confirmDelete={confirmDelete}
        setConfirmDelete={setConfirmDelete}
        handleDeleteDraw={handleDeleteDraw}
      />
    </Grid>
  );
};
